import { Provider } from '@angular/core';
import {
  AUTOMATION_BUILDER_CONFIG,
  AutomationBuilderConfig,
  IFieldChangeFieldDef,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  createEnumList,
  orderStatusOptions,
} from '@kinet-open-network/shared/data-access/model';
import { flowOrderTypeOptions } from '@kinet-open-network/shared/data-access/model-pbgas';
import { GenerateCustomerRentalInvoiceActionComponent } from './actions/generate-customer-rental-invoice-action.component';
import { RefreshActionComponent } from './actions/refresh-action.component';
import { RefreshStockMovesActionComponent } from './actions/refresh-stock-moves-action.component';
import { RegenerateOrderStockMovesActionComponent } from './actions/regenerate-order-stock-moves-action.component';
import { WriteBottleOwnersToOnixActionComponent } from './actions/write-bottle-owners-to-onix-action.component';
import { WriteOrderToOnixActionComponent } from './actions/write-order-to-onix-action.component';

const orderFieldChangeFields: IFieldChangeFieldDef[] = [
  {
    key: 'status',
    label: 'Stav objednávky',
    type: 'enum',
    options: createEnumList(orderStatusOptions),
  },
  {
    key: 'type',
    label: 'Typ objednávky',
    type: 'enum',
    options: createEnumList(flowOrderTypeOptions),
  },
  { key: 'date', label: 'Dátum', type: 'date' },
  { key: 'note', label: 'Poznámka', type: 'string' },
  { key: 'externalNumber', label: 'Externé číslo', type: 'string' },
  { key: 'customerId', label: 'ID zákazníka', type: 'number' },
  { key: 'totalBase', label: 'Celková cena bez DPH', type: 'number' },
];

const pbgasAutomationBuilderConfig: AutomationBuilderConfig = {
  actions: {
    'refresh-stock-items': RefreshActionComponent,
    'refresh-customers': RefreshActionComponent,
    'refresh-group-prices': RefreshActionComponent,
    'refresh-customer-prices': RefreshActionComponent,
    'refresh-stock-moves': RefreshStockMovesActionComponent,
    'refresh-orders': RefreshActionComponent,
    'write-order-to-onix': WriteOrderToOnixActionComponent,
    'generate-customer-rental-invoice':
      GenerateCustomerRentalInvoiceActionComponent,
    'write-bottle-owners-to-onix': WriteBottleOwnersToOnixActionComponent,
    'regenerate-order-stock-moves': RegenerateOrderStockMovesActionComponent,
  },
  conditions: {},
  fieldChangeContextFields: {
    order: orderFieldChangeFields,
  },
};

export function provideAutomationsBuilderConfig(): Provider {
  return {
    provide: AUTOMATION_BUILDER_CONFIG,
    useValue: pbgasAutomationBuilderConfig,
  };
}
